import Logo from './Logo';
import Appreciate from './Svgs/AppreciateSvg';
import Clapping from './Svgs/ClappingSvg';
import FoldedHands from './Svgs/FoldedHandsSvg';
import HeartEmoji from './Svgs/HeartEmojiSvg';
import Santa from './Svgs/SantaSvg';
import StarStruck from './Svgs/StarStruckSvg';
import Thinking from './Svgs/ThinkingSvg';

export const Icons = {
  Logo,
  Appreciate,
  HeartEmoji,
  StarStruck,
  Thinking,
  Clapping,
  FoldedHands,
  Santa,
};
